module.exports = {"TOP_NAV.FIND_A_DOCTOR":"Doctify, your Find a Doctor specialist","TOP_NAV.FIND_A_DOCTOR_ALT":"Your 'Find A Doctor' Specialist | Doctify"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en.json
// module id = 1137
// module chunks = 0